// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Xikl9","rootCenter":"LoadMoreObserver_rootCenter__1SefS","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3u1cb"};